import { ProductVariantType } from '../../../common/enums/common';
import {
  IColorVariant,
  IProduct,
  IProductVariant,
} from '../../../services/helper/productInterfaces';
import { groupByItems } from '../../../utils/objectUtils';
import { Carousel, CarouselItem } from '../carousel';
import ProductTile from '../productTile';

interface IProductTileCarousel {
  data: IProduct[];
  noOfTilesToDisplay: number;
  carouselId: string;
  displayNavControls: boolean;
  displayNavIndicators: boolean;
  className?: string;
  carouselItemClassName?: string;
  autoSlideInSec?: number;
  colorScheme: Record<string, Record<string, string>>;
  variantType: ProductVariantType;
  onProductTileClick: (productVariant: IProductVariant, productId: string) => void;
  onVariantChange?: (variant: IColorVariant) => void;
  carouselInnerStyles?: string;
}

export const ProductTileCarousel = ({
  data,
  noOfTilesToDisplay,
  carouselId,
  displayNavControls,
  displayNavIndicators,
  colorScheme,
  className,
  carouselItemClassName,
  autoSlideInSec,
  variantType,
  onProductTileClick,
  onVariantChange,
  carouselInnerStyles
}: IProductTileCarousel) => {
  if (!data || data?.length === 0) return null;
  const tilesData = groupByItems(data, noOfTilesToDisplay);
  let tilePositionStyle = `mx-sm w-full aspect-auto z-10`;
  let masterVariantId = '0';
  if (!tilesData || tilesData?.length === 0) return null;

  return tilesData && (
    <Carousel
      carouselData={tilesData}
      displayNavbars={true}
      displayNavIndicators={displayNavIndicators}
      displayNavControllers={displayNavControls}
      positionNavIndicators="onNavbar"
      positionNavControllers="onMedia"
      data-testid={carouselId}
      className={className}
      isAutoSlide={autoSlideInSec !== 0}
      autoSlideInSec={autoSlideInSec}
      navControllersClassName={`pt-md text-darkNavBlue hover:text-navBlue focus:text-darkNavBlue !w-2md !h-2md`}
      carouselInnerStyles={carouselInnerStyles}
      showFocus={true}
    >
      {tilesData.map((tiles: IProduct[], index: number) => {
        if (tiles.length < noOfTilesToDisplay) {
          tilePositionStyle += ` w-1/${noOfTilesToDisplay}`
        }
        return (
          <CarouselItem isActive={index === 0} key={index}>
            <div className={`mx-4 grid grid-cols-${noOfTilesToDisplay} gap-3 ${carouselItemClassName} justify-between justify-items-center max-w-[1120px] xl:my-0 xl:mx-auto`}>
              {tiles.map((item: IProduct, idx: number) => {
                const productId = Object.keys(item)[0];
                const productVariants: IProductVariant[] = item[productId];
                productVariants?.forEach((variant: IProductVariant) => {
                  if (variant.variant === 'masterVariant') {
                    masterVariantId = variant.id;
                    return;
                  }
                });
                return (
                  productVariants.length > 0 && (
                    <div
                      key={`carousel-product-tile-${index}-${idx}`}
                      className={`${tilePositionStyle}`}
                    // tabIndex={idx}
                    >
                      <ProductTile
                        productId={productId}
                        productVariants={productVariants}
                        showProductVariants={true}
                        onTileClick={onProductTileClick}
                        variantType={variantType}
                        colorScheme={colorScheme}
                        productTileId="productTileCarousel"
                        className={'p-2 md:p-3 w-[100%] h-[190px] sm:h-[200px] md:h-[240px] lg:h-[280px] xl:h-[325px] max-h-[325px] xl:max-w-[365px]'}
                        onVariantChange={onVariantChange}
                        key={`carousel-product-tile-${productId}-${idx}`}
                        imageClassName={'w-[120px] h-[50px] sm:w-[200px] sm:h-[70px] xl:w-[300px] xl:h-[108px] overflow-hidden relative pt-2 md:pt-0'}
                        tagClassName={'text-[7px] md:text-[8px] xl:text-xs font-medium'}
                        imgClassName='scale-[1.1] hover:scale-[1.2]'
                        productAttrClassName='h-[70px] md:h-[100px] xl:h-[131px]'
                      />
                    </div>
                  )
                );
              })}
            </div>
          </CarouselItem>
        );
      })}
    </Carousel>
  );
};
